import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private refresh$: Observable<void> | null = null;

  constructor(private http: HttpClient) {}

  refreshToken(): Observable<void> {
    if (this.refresh$) {
      return this.refresh$;
    }

    this.refresh$ = this.http
      .post<void>(environment.apiUrl + '/auth/refresh', {})
      .pipe(
        shareReplay(1),
        finalize(() => {
          this.refresh$ = null;
        }),
      );

    return this.refresh$;
  }
}
